export const CONFIG_PAGES = {
  DOCTOR_HOW_IT_WORKS: '8'
};
